module.exports = __webpack_public_path__ + "static/media/logo_black.dd8dff33.png";